import sliceCreator from '../../index.jsx';
import {CREATE_DAILY_PUNCH} from '../../../constants/index.jsx';
const _createDailyPunchAction = sliceCreator('CREATE_DAILY_PUNCH', CREATE_DAILY_PUNCH, 'post');

const { asyncAction: createDailyPunchAction, reducer, clearData: clearCreateDailyPunchAction } = _createDailyPunchAction;

export default reducer;

export {
    createDailyPunchAction,
    clearCreateDailyPunchAction
}